import ROUTES from "@app/common/routes";
import type { UserSettings } from "@app/common/types";
import * as UserSettingsUtils from "@app/common/utils/userSettingsUtils";

import { Bold } from "@rui/styles";

export const CALENDAR_SETTING_DESCRIPTIONS = [
  {
    id: "calendarPermissionLevel",
    getDescriptionFromSettings: ({ calendarPermissionLevel }: UserSettings) => {
      switch (calendarPermissionLevel) {
        case "all":
          return (
            <>
              Read Assistant will <Bold>auto-join all meetings</Bold>
            </>
          );
        case "hosting_only":
          return (
            <>
              Read Assistant will <Bold>auto-join meetings you host</Bold>
            </>
          );
        case "invite_only":
        default:
          return (
            <>
              Read Assistant will <Bold>only join meetings when invited</Bold>
            </>
          );
      }
    },
    manageUrl: ROUTES.USER_SETTINGS_JOIN_PREFERENCES,
  },
  {
    id: "afterMeetingUpdateCalendarEventWithRecap",
    getDescriptionFromSettings: ({
      afterMeetingUpdateCalendarEventWithRecap,
    }: UserSettings) => {
      return (
        <>
          Read{" "}
          <Bold>
            {afterMeetingUpdateCalendarEventWithRecap ? "will" : "will not"}{" "}
            update calendar events
          </Bold>{" "}
          with a meeting summary
        </>
      );
    },
    manageUrl: ROUTES.USER_SETTINGS_REPORTING,
  },
  {
    id: "emailMeetingRecaps",
    getDescriptionFromSettings: (settings: UserSettings) => {
      const meetingRecapSettings =
        UserSettingsUtils.getEnabledUserDistributionSettingForCategoryAndProvider(
          settings,
          { category: "meeting_report", provider: "email" }
        );

      const recipients =
        meetingRecapSettings?.sendTo === "participants_with_access"
          ? "all participants with access"
          : meetingRecapSettings?.sendTo === "me"
            ? "only me"
            : "no one";

      return (
        <>
          Read will send meeting recaps via email to <Bold>{recipients}</Bold>
        </>
      );
    },
    manageUrl: ROUTES.USER_SETTINGS_REPORTING,
  },
];
